import axiosInstance from "../axios/index";
import axios from "axios";
function HttpClient() {
  return {
    get: axiosInstance.get,
    post: axiosInstance.post,
    patch: axiosInstance.patch,
    put: axiosInstance.put,
    delete: axiosInstance.delete,
  };
}

export default HttpClient();
